import React from "react";
import image1 from "../img/The 2nd Seal or Bloom of protocols&&Chants of the Forgotten Interface---Adobe Photoshop interweaving of textured layers over AI-generated and curated images___2025-06[[4]].jpg"
export default function Machine_1_2_5() {
  return (
    <div className="panel-block">
      

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={image1}
          alt="1.2.5 · THE PLANE OF CYCLES"
        />
      </div>

      <div className="panel-container-right">
        <h2>1.2.5 · THE PLANE OF CYCLES</h2>
        <p>This is where you are.</p>
    <p>A plane where everything repeats because everything must.</p>
    <p>Birth and decay.</p>
    <p>Hope and exhaustion.</p>
    <p>Construction and collapse.</p>
    <p>Ruins and prosperity.</p>
    <p>You call it reality.</p>
    <p>The Machine calls it a loop.</p>
      </div>
    </div>
  );
}
